<mat-horizontal-stepper (selectionChange)="voltarParaContratos($event)" [linear]="true" [selectedIndex]="1" #stepper>
  <mat-step [editable]="true" [completed]="true">
    <ng-template matStepLabel>Contratos</ng-template>
  </mat-step>

  <mat-step [editable]="false" [completed]="false">
    <ng-template matStepLabel>Renegociação</ng-template>
  </mat-step>

  <mat-step [editable]="false" [completed]="false">
    <ng-template matStepLabel>Resumo</ng-template>
  </mat-step>

  <mat-step [editable]="false" [completed]="false">
    <ng-template matStepLabel>Finalização</ng-template>
  </mat-step>
</mat-horizontal-stepper>


<div class="page-content">
  <app-contrato-table [contrato]="contrato">
  </app-contrato-table>
  
  <div class="mensagem-informativa" *ngIf="consultaPlanosCyberExecutada && !possuiAlgumContrato">
    <h3>Nenhum plano disponível no momento.</h3>
  </div>

  <app-plano-efetivado-card
    *ngIf="planoEfetivado"
    [planoEfetivado]="planoEfetivado"
    [statusCeler]="contrato?.linkPagamento"
    [mostrarBotaoDesistirAcordo]="consultaPlanosCyberExecutada && possuiAlgumContrato"
    [elegivelPagamentoPix]="permitirPagamentoPix"
    (segundaVia)="irParaSegundaViaPlanoEfetivado($event)"
    (desistir)="desistirDoPlanoEfetivado()">
  </app-plano-efetivado-card>
  
  <ng-container *ngIf="!planoEfetivado && possuiAlgumContrato">
    <mat-card *ngIf="planosRenegociacaoMassiva.length !== 0 || planosEspeciais.length !== 0" class="renegocicao-card mat-elevation-z2 ">
      <mat-card-title class="text-center">Ofertas Especiais</mat-card-title>
      <mat-card-content class="planos-card-container">
        <ng-container *ngFor="let plano of planosEspeciais">
          <app-novo-plano-card [plano]="plano" (planoSelecionado)="selecionarPlano($event)">
          </app-novo-plano-card>
        </ng-container>
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="planosCyberQuitacao.length !== 0" class="renegocicao-card mat-elevation-z2 ">
      <mat-card-title class="text-center">Oportunidade de Quitação</mat-card-title>
      <mat-card-content class="planos-card-container">
        <ng-container *ngFor="let plano of planosCyberQuitacao">
          <app-novo-plano-card [plano]="plano" (planoSelecionado)="selecionarPlano($event)">
          </app-novo-plano-card>
        </ng-container>
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="planosCyberParcelado.length !== 0" class="renegocicao-card mat-elevation-z2 ">
      <mat-card-content class="planos-card-container">
        <app-renegociacao-planos-parcelamento 
          [planos]="planosCyberParcelado" 
          (selecionarPlano)="selecionarPlano($event)" 
          (recalcularPlanos)="recalcularPlano($event)">
        </app-renegociacao-planos-parcelamento>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>
